import { useState } from "react"
import { SearchSelect } from "../shared/searchSelect"
import { SearchFiltersModal } from "../shared/searchFiltersModal"
import stringHelpers from "../../utilities/stringHelpers"

export const AllocateBreachesFormFiltersModal = ({
    showModal,
    handleClose,
    handleConfirm,
    initialSelectedClient,
    initialAppliedFilters,
    clients = []
}) => {
    const [selectedClient, setSelectedClient] = useState(initialSelectedClient)
    const [appliedFilters, setAppliedFilters] = useState(initialAppliedFilters)

    const clearLocalFilters = () => {
        setSelectedClient("")
        setAppliedFilters(null)
    }

    return (
        <SearchFiltersModal
            title="Filter Results"
            handleClose={ handleClose }
            handleConfirm={ () => handleConfirm({ selectedClient, appliedFilters }) }
            showModal={ showModal }
            key="allocate-breaches-form-filters-modal"
            handleReset={ clearLocalFilters }
        >
            <div className="w-100">
                <div className="d-flex flex-column mb-2">
                    <label className="m-0 mr-2 mb-1 nowrap">Client</label>
                    <SearchSelect
                        defaultLabel="All"
                        width="100%"
                        options={ [{ value: "", label: "All" }, ...clients.map(item => ({ value: item.id, label: item.name }))] }
                        onSelect={ value => {
                            if (!stringHelpers.isNullOrEmpty(value)) {
                                setSelectedClient(value)
                                const client = clients.find(item => item.id === value)
                                setAppliedFilters(prevState => ({ ...prevState, "Client": client?.name }))
                            } else {
                                setSelectedClient("")
                                setAppliedFilters(prevState => {
                                    const updatedFilters = { ...prevState }
                                    delete updatedFilters["Client"]
                                    return Object.keys(updatedFilters).length > 0 ? updatedFilters : null
                                })
                            }
                        } }
                        selected={ !stringHelpers.isNullOrEmpty(selectedClient) ? selectedClient : null }
                    />
                </div>
            </div>
        </SearchFiltersModal>
    )
}
